// extracted by mini-css-extract-plugin
module.exports = {"container":"FoodSidebarOrderDetails_container__2b1bf"};